// =============================================================================
// ESPOLIDAR WEB ADMIN - MEDIA HOOKS
// =============================================================================

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { mediaApi } from '../services/api'
import toast from 'react-hot-toast'

export function useMedia(mediaType?: string) {
  return useQuery({
    queryKey: ['media', mediaType],
    queryFn: () => mediaApi.list(mediaType),
  })
}

export function useUploadMedia() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ file, name }: { file: File; name?: string }) =>
      mediaApi.upload(file, name),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['media'] })
      toast.success('File caricato')
    },
    onError: () => {
      toast.error('Errore caricamento file')
    },
  })
}

export function useDeleteMedia() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: mediaApi.delete,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['media'] })
      toast.success('File eliminato')
    },
    onError: () => {
      toast.error('Errore eliminazione file')
    },
  })
}
